import { DPPayPeriodSummary } from "Shared/types/Payments";

type LineProp = {
  color: "green" | "blue" | "orange";
  start: number;
  end: number;
};

export function createLineProps(
  {
    totalTransferredEarlyAmountCents,
    remainderAmountCents,
    negativeBalancePaidSettlementAmountCents,
  }: DPPayPeriodSummary,
  width: number
): LineProp[] {
  const sum =
    totalTransferredEarlyAmountCents +
    (remainderAmountCents || 0) +
    (negativeBalancePaidSettlementAmountCents || 0);
  const greenPct = totalTransferredEarlyAmountCents / sum;
  const greenEnd = width * greenPct;
  const redPct = (negativeBalancePaidSettlementAmountCents || 0) / sum;
  const redEnd = width * redPct + greenEnd;

  const lines: LineProp[] = [];
  if (totalTransferredEarlyAmountCents)
    lines.push({
      color: "green",
      start: 0,
      end: greenEnd,
    });
  if (negativeBalancePaidSettlementAmountCents) {
    lines.push({
      color: "orange",
      start: greenEnd,
      end: redEnd,
    });
  }
  if (remainderAmountCents)
    lines.push({
      color: "blue",
      start: redEnd,
      end: width,
    });

  return lines;
}
